import React, { useEffect, useState, } from 'react'
import { useSelector, useDispatch, } from 'react-redux'
import moment from 'moment'
import { Helmet, } from "react-helmet"
import { appName, } from '../../../constants'
import Loading from '../../layouts/Loading'
import DeleteAccountModal from './DeleteAccountModal'
import { updateSettings, } from '../../../redux/actions/settingsActions'

import "./SettingsComponent.scss"
import ErrorComponent from '../../layouts/ErrorComponent'

export default function SettingsComponent() {
  const [username, setUsername] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [dob, setDob] = useState(
    moment().subtract(18, 'years').toDate()
  )
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [passwordConfirmation, setPasswordConfirmation] = useState("")
  const [error, setError] = useState("")
  
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()

  const state = useSelector(state => ({
    auth: state.auth,
    settings: state.settings,
  }))

  useEffect(() => {
    loadData()
    setLoading(false)
  }, [])

  useEffect(() => {
    if (false === state.settings.loading) {
      setLoading(false)
    }
    if (state.settings.error) {
      setError(state.settings.error)
    }
    if (state.settings.data) {
      loadData()
    }
  }, [state.settings])
  
  const loadData = async () => {
    let storage = localStorage.getItem("user-token")
    if (storage !== null) {
      storage = JSON.parse(storage)
      const {
        firstName,
        lastName,
        email,
        username,
        dob,
      } = storage.data.user
      setUsername(username)
      setFirstName(firstName)
      setLastName(lastName)
      setEmail(email)
      setDob(moment(dob, "YYYY-MM-DD").toDate())
      setPassword("")
      setPasswordConfirmation("")
      setError("")
    }
  }

  const onFirstNameChange = (e) => {
    setFirstName(e.target.value)
  }

  const onLastNameChange = (e) => {
    setLastName(e.target.value)
  }

  const onEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const onPasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const onPasswordConfirmationChange = (e) => {
    setPasswordConfirmation(e.target.value)
  }

  const onDobChange = (e) => {
    setDob(moment(e.target.value).toDate())
  }

  const updateAccount = updateCreds => {
    dispatch(updateSettings(updateCreds))    
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const requestObj = {
      dob: moment(dob).format("YYYY-MM-DD"),
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      passwordConfirmation: "",
    }
    if (firstName) {
      requestObj.firstName = firstName
    }
    if (lastName) {
      requestObj.lastName = lastName
    }
    if (email) {
      requestObj.email = email
    }
    if (password) {
      requestObj.password = password
    }
    if (passwordConfirmation) {
      requestObj.passwordConfirmation = password
    }
    updateAccount(requestObj)
  }

  const renderDob = () => {
    return moment(dob).format('DD MMM YYYY')
  }

  if (state.auth.loading || loading) {
    return <>
      <Helmet>
        <title>Settings - {appName}</title>
      </Helmet>
      <div className="container settings-container text-center mt-9 mb-8">
        <Loading />
      </div>
    </>
  }
  
  return (
    <>
      <Helmet>
        <title>Settings - {appName}</title>
      </Helmet>
      <div className='container settings-container py-7 py-lg-10'>
        <div className="col-md-4 offset-md-4">
          <h3 className="lead settings-title">Settings</h3>
          <form method="post" onSubmit={onSubmit}>
            <ErrorComponent error={state.auth.error || error} />
            <div className="form-group mb-3">
              <label htmlFor="username">
                Username:
              </label>
              <input 
                name="username" 
                className="form-control"
                value={username}
                disabled
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="firstName">
                First Name:
              </label>
              <input 
                name="firstName" 
                className="form-control"
                value={firstName}
                onChange={onFirstNameChange}
                placeholder="Enter First Name"
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="lastName">
                Last Name:
              </label>
              <input 
                name="lastName" 
                className="form-control"
                value={lastName}
                onChange={onLastNameChange}
                placeholder="Enter Last Name"
              />
            </div>
            <div className="dob-container">
              <div className='dob-title'>
                <span className='dob-label'>Date of Birth:</span> {renderDob()}
              </div>
              <div className="dob-choose-container text-center">
                <input
                  type="date"
                  name="dob"
                  value={moment(dob).format("YYYY-MM-DD")}
                  onChange={onDobChange}
                />
              </div>
            </div>
            <div className="form-group mb-3">
              <label htmlFor="email">
                Email:
              </label>
              <input 
                name="email" 
                className="form-control"
                value={email}
                onChange={onEmailChange}
                placeholder="Enter Email"
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="password">
                Password:
              </label>
              <input 
                type="password"
                name="password" 
                className="form-control"
                value={password}
                onChange={onPasswordChange}
                placeholder="Enter Password"
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="passwordConfirmation">
                Password Confirmation:
              </label>
              <input 
                type="password"
                name="passwordConfirmation" 
                className="form-control"
                value={passwordConfirmation}
                onChange={onPasswordConfirmationChange}
                placeholder="Enter Password Confirmation"
              />
            </div>
            <div className="settings-btn-container">
              <div className="delete-account-container mb-3">
                <DeleteAccountModal />
              </div>
              <input 
                type="submit" 
                className="btn btn-success joystick-success"
                value="UPDATE SETTINGS"
              />
            </div>
          </form>
        </div>
      </div>
    </>       
  )
}
